import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AuthDialog } from "@/components/AuthDialog";
import { BasketProvider } from "@/context/BasketContext";
import { BasketDrawer } from "@/components/BasketDrawer";
import { StoryNameChoice } from "@/components/StoryNameChoice";
import Studio from "@/pages/Studio";
import SharePage from "@/pages/SharePage";
import EmbedPage from "@/pages/EmbedPage";
import LibraryPage from "./pages/LibraryPage";
import ReferenceTrialPage from "./pages/ReferenceTrialPage";
import PassportPage from "./pages/PassportPage";
import ReorderPage from "./pages/ReorderPage";
import LabelsPage from "./pages/LabelsPage";
import ShopAppPage from "./pages/ShopAppPage";
import ShopAdminOrders from "./pages/ShopAdminOrders";
import ShopAdminOrderDetail from "./pages/ShopAdminOrderDetail";
import ShopAdminQueue from "./pages/ShopAdminQueue";
import ShopAdminSpendGate from "./pages/ShopAdminSpendGate";
import ShopAdminHeld from "./pages/ShopAdminHeld";
import QrLandingPage from "./pages/QrLandingPage";
import MyDucksPage from "./pages/MyDucksPage";
import LoginPage from "./pages/LoginPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import AccountPage from "./pages/AccountPage";
import AdminDashboard from "./pages/AdminDashboard";
import { RequireAuth } from "./components/RequireAuth";
import { GateGuard } from "./components/GateGuard";
import AccountsPage from "./pages/AccountsPage";
import PartnerPage from "./pages/PartnerPage";

function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
      <AuthProvider>
        <BasketProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<GateGuard><Studio /></GateGuard>} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/reset/:token" element={<ResetPasswordPage />} />
              <Route path="/s/:id" element={<SharePage />} />
              <Route path="/q/:short" element={<QrLandingPage />} />
              <Route path="/embed/:id" element={<EmbedPage />} />
              <Route path="/passport/:id" element={<PassportPage />} />
              <Route path="/labels/:id" element={<LabelsPage />} />
              <Route path="/shop-app" element={<ShopAppPage />} />
              <Route path="/shop-app/orders" element={<ShopAdminOrders />} />
              <Route path="/shop-app/orders/:orderId" element={<ShopAdminOrderDetail />} />
              <Route path="/shop-app/queue" element={<ShopAdminQueue />} />
              <Route path="/shop-app/spend-gate" element={<ShopAdminSpendGate />} />
              <Route path="/shop-app/held" element={<ShopAdminHeld />} />
              <Route path="/reorder/:id" element={<ReorderPage />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/orders" element={<ShopAdminOrders />} />
              <Route path="/admin/orders/:orderId" element={<ShopAdminOrderDetail />} />
              <Route path="/admin/queue" element={<ShopAdminQueue />} />
              <Route path="/admin/spend-gate" element={<ShopAdminSpendGate />} />
              <Route path="/admin/held" element={<ShopAdminHeld />} />
              <Route path="/admin/accounts" element={<AccountsPage />} />
              <Route path="/partner" element={<GateGuard><RequireAuth><PartnerPage /></RequireAuth></GateGuard>} />
              <Route path="/library" element={<GateGuard><LibraryPage /></GateGuard>} />
              <Route path="/library/reference-trial" element={<GateGuard><ReferenceTrialPage /></GateGuard>} />
              <Route path="/my-ducks" element={<GateGuard><RequireAuth><MyDucksPage /></RequireAuth></GateGuard>} />
              <Route path="/account" element={<GateGuard><RequireAuth><AccountPage /></RequireAuth></GateGuard>} />
            </Routes>
            <AuthDialog />
            <BasketDrawer />
          </BrowserRouter>
        </BasketProvider>
      </AuthProvider>
      <StoryNameChoice />
      <Toaster position="top-center" richColors />
    </ThemeProvider>
  );
}

export default App;
